import fetcher from "../../lib/fetcher";
import useSWR from "swr";

interface IApartmentBuildingAreaMinMaxResponse {
  min: number;
  max: number;
}

interface IApartmentBuildingAreaMinMaxResponseWrapper {
  data: IApartmentBuildingAreaMinMaxResponse;
}

const useApartmentBuildingAreaMinMax = (
  id?: number | null,
  type?: number | null
) => {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    id && type ? `/building/${id}/available-area-limits` : null,
    (url) =>
      id && type
        ? fetcher.swr<IApartmentBuildingAreaMinMaxResponseWrapper>(url, {
            params: { typeId: type },
          })
        : null,
    {}
  );

  return { minMaxArea: data?.data, error, isLoading, isValidating, mutate };
};

export default useApartmentBuildingAreaMinMax;
